import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: 'img[imgFallback]',
})
export class ImageFallbackDirective {
  @Input() imgFallback!: string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('error') applyFallbackImage() {
    const imageElmRef: HTMLImageElement = this.elementRef.nativeElement;

    // If we are using imgLazyLoad directive, then it's opacity should reset to 1.
    this.renderer.setStyle(imageElmRef, 'opacity', '1');
    this.renderer.setProperty(
      imageElmRef,
      'src',
      this.imgFallback ||
        'https://media.umangapp.in/app/ico/service/NationalEmblem23.png'
    );
  }
}
